module.exports = "/assets/data/be875875def47e938ca7243dae563925-ME7.data.json";